<template lang="pug">
  .stroke-line(:class="side")
    .stroke-line_inner
</template>

<style lang="sass" scoped>
  @import '../assets/sass/_vars.sass'

  .stroke-line
    display: flex
    height: 7px
    background: transparent

    .right
      justify-content: flex-end
    .center
      justify-content: center
  .stroke-line_inner
    height: 100%
    width: 10%
    background: $primary-color
    border-radius: 0 0 0 10px
</style>

<script>
export default {
  props: {

  },
  data() {
    return {
      side: 'right'
    };
  }
};
</script>




// WEBPACK FOOTER //
// resources/src/components/StrokeLine.vue?68998c0e